const hasValue = (value) => String(value ?? "").trim().length > 0;

export const getAuthenticatedRedirectPath = (userDetail) => {
  if (!userDetail) {
    return "/login";
  }

  if (String(userDetail?.userStatus ?? "").trim().toLowerCase() === "lead") {
    return "/pricing";
  }

  if (!hasValue(userDetail?.rpfId)) {
    return "/risk-profile";
  }

  return "/dashboard";
};
